import { TicketClassCategory } from '../../constants';
import { AVAILABLE_TICKET_STATUS } from '../../containers/ticketSelection/constants';
import { Ticket, TicketVariant } from '../../models/tickets';
import { CheckoutState } from '../../state';
import { getTicketsById } from './pureSelectors';

const hasAddonVariantAvailable = (variants: TicketVariant[]) =>
    variants &&
    variants.some(
        (variant) => variant.onSaleStatus === AVAILABLE_TICKET_STATUS,
    );

const isAddonTicketAvailable = ({
    category,
    onSaleStatus,
    variants,
}: Pick<Ticket, 'category' | 'onSaleStatus' | 'variants'>) =>
    category === TicketClassCategory.addOn &&
    (onSaleStatus === AVAILABLE_TICKET_STATUS ||
        hasAddonVariantAvailable(variants));

export const getHasAddonsTicketsAvailable = (state: CheckoutState) =>
    Object.values<Ticket>(getTicketsById(state)).some(
        ({ category, onSaleStatus, variants }) =>
            isAddonTicketAvailable({ category, onSaleStatus, variants }),
    );
